module.exports = __webpack_public_path__ + "img/56-image-1-1@2x.36b6e181.png";